import { Icon, type IconName } from '../../components/Icon';
import { creditRateTable } from '../../i18n/credit-rates';
import { useI18n } from '../../i18n/i18n-context';

const ICONS = {
  text: 'letters',
  tools: 'wand',
  dictation: 'microphone',
  speech: 'speaker',
  imageText: 'image',
} as const satisfies Record<string, IconName>;

export function CreditRatesTable() {
  const { caption, headings, rows } = creditRateTable(useI18n());
  return (
    <table className="credit-rates-table">
      <caption>{caption}</caption>
      <thead>
        <tr>
          {headings.map((heading) => (
            <th key={heading} scope="col">
              {heading}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map(({ id, label, credits, basis }) => (
          <tr key={id}>
            <th scope="row">
              <span className="credit-rate-activity">
                <Icon name={ICONS[id]} />
                {label}
              </span>
            </th>
            <td className="credit-rate-amount">{credits}</td>
            <td>{basis}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
